// Headless export registration for Shelf Test (single-output composite).
// Legacy parity (pptx.coffee getShelfTestParams): sh generates exactly ONE PNG —
// the shelf composite (bg image + heatmap overlay); the ProductMetrics HC chart is
// metadata-only there (chartType/dataType/sort), rendered natively by the PPTX
// backend. So we register the live ShelfChart leaf, not a two-output dispatcher.
// `ec` (e-commerce) is intentionally NOT registered: formatSVG early-returns on
// store === 'ecommerce' and legacy never produces a PNG for it — the driver
// forwards ec metadata without a render call (same class as compare-items).
// params.shelfViewMode = report-param `tscv{key}` (default 'heatmap' per
// the block's DEFAULT_SHELF_VIEW); 'shelfs' renders the bare shelf, no overlay.
// Image follows the hm flow: preview.original.{url,path,width,height}, never
// base64 in the payload — ShelfChart seeds window.AYTM_shelfImage_{id} and the
// export step converts URL→base64 via the live toDataUrl.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/08-sh.md

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import ShelfChart from '@aytm/app/stats/page/question-views/sh/components/shelf/Chart'

const shEntry: ExportableChart = {
  Component: ShelfChart,
  toProps: (data: any, params: any) => ({
    id: data.id,
    questionKey: data.questionKey,
    shelfData: data.shelf_preview_data,
    shelfType: data.shelfType,
    shelfViewMode: params.shelfViewMode || 'heatmap',
    shelfAnswer: data.answer,
    preview: data.preview,
    onComplete: undefined
  })
}

ExportableCharts.register('sh', shEntry)
